'use client'

import { useParams } from 'next/navigation'
import { createContext, useContext, useReducer } from 'react'

export const UnitContext = createContext(null)

const reducer = (state, action) => {
	return action.unit
}

export function UnitProvider({ children }) {
	const { lang } = useParams()
	const defaultUnit = lang === 'en_US' ? 'Imperial' : 'Metric'

	const [unit, dispatch] = useReducer(reducer, defaultUnit)
	return (
		<UnitContext.Provider value={{ unit, dispatch }}>
			{children}
		</UnitContext.Provider>
	)
}
